import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable no-return-assign */
import React, { Component, Children, cloneElement } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';
var MAIN_CLASS = 'tds-popover';

var Popover = /*#__PURE__*/function (_Component) {
  _inherits(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      rendered: false
    });

    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.__mouseLeaveTimeout = null;
      var rendered = this.state.rendered;
      var propsRendered = this.props.rendered;
      /**
       * If the popover is controlled (so, we pass down `rendered` prop)
       * we can't add event listener to the body as we won't know how
       * to prevent the trigger (outside of the popover) to fire a second
       * `this.toggleTooltip` as it will be called when using our
       * external button to close the popover.
       */

      if (typeof propsRendered === 'boolean') {
        return;
      }

      if (prevState.rendered && !rendered || prevProps.rendered && !propsRendered) {
        document.body.removeEventListener('click', this.closeFn);
      }

      if (!prevState.rendered && rendered || !prevProps.rendered && propsRendered) {
        if (!this.closeFn) {
          this.setCloseFn();
        }

        document.body.addEventListener('click', this.closeFn);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.toggleTooltip(false);
      this.clearMouseLeaveTimeout();
      document.body.removeEventListener('click', this.closeFn);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      var _this2 = this;

      this.clearMouseLeaveTimeout();
      this.__mouseLeaveTimeout = setTimeout(function () {
        return _this2.toggleTooltip(false);
      }, this.props.mouseLeaveTimeout);
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter() {
      this.clearMouseLeaveTimeout();
      this.toggleTooltip(true);
    }
  }, {
    key: "setCloseFn",
    value: function setCloseFn() {
      var _this3 = this;

      this.closeFn = function (_ref) {
        var target = _ref.target;
        // clickedInsideOfPopoverTrigger is needed 'coz if I click on a button
        // to trigger the popover, then if I click again that button
        // I want the Popover to close via that button's click, and
        // not via this function
        var clickedInsideOfPopoverTrigger = !(_this3._triggerWrapper && _this3._triggerWrapper.contains === 'function' && !_this3._triggerWrapper.contains(target));
        var shouldClose = !_this3._wrapper.contains(target) || _this3.props.forceCloseOnClick;
        var shouldCloseOtherCheck = clickedInsideOfPopoverTrigger || _this3.props.tooltipBehavior;

        if (shouldClose && shouldCloseOtherCheck) {
          _this3.toggleTooltip(false);
        }
      };
    }
  }, {
    key: "clearMouseLeaveTimeout",
    value: function clearMouseLeaveTimeout() {
      if (this.__mouseLeaveTimeout) {
        clearTimeout(this.__mouseLeaveTimeout);
      }
    }
  }, {
    key: "toggleTooltip",
    value: function toggleTooltip(value) {
      var _this4 = this;

      var callOnClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (typeof this.props.rendered === 'boolean') {
        // controlled
        var rendered = typeof value !== 'boolean' ? !this.props.rendered : value;
        this.props.onToggle(rendered, true);

        if (callOnClose && !rendered) {
          this.props.onClosed();
        }
      } else {
        var prevRendered = this.state.rendered;

        var _rendered = typeof value !== 'boolean' ? !prevRendered : value;

        this.setState({
          rendered: _rendered
        }, function () {
          _this4.props.onToggle(_this4.state.rendered);

          if (callOnClose && !_this4.state.rendered) {
            _this4.props.onClosed();
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this5 = this;

      var _this$props = this.props,
          children = _this$props.children,
          placement = _this$props.placement,
          width = _this$props.width,
          content = _this$props.content,
          push = _this$props.push,
          theme = _this$props.theme,
          closable = _this$props.closable,
          tooltipBehavior = _this$props.tooltipBehavior,
          onFocusBehavior = _this$props.onFocusBehavior,
          className = _this$props.className,
          title = _this$props.title,
          icon = _this$props.icon,
          forceCloseOnClick = _this$props.forceCloseOnClick;
      var stateRendered = this.state.rendered;
      var propsRendered = this.props.rendered;
      var rendered = typeof propsRendered === 'boolean' ? propsRendered : stateRendered;
      var tooltipClassName = classNames(MAIN_CLASS, (_classNames = {}, _defineProperty(_classNames, "".concat(MAIN_CLASS, "--left"), placement === 'left'), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--top"), placement === 'top'), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--right"), placement === 'right'), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--bottom"), placement === 'bottom'), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--push-left"), push === 'left'), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--push-right"), push === 'right'), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--alternative"), theme === 'alternative'), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--closable"), closable), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--icon-").concat(icon), icon), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--disable-animation"), tooltipBehavior), _defineProperty(_classNames, "".concat(MAIN_CLASS, "--is-tooltip"), tooltipBehavior), _defineProperty(_classNames, className, !!className), _classNames));
      var buttonClassNames = classNames('tds-popover__button', _defineProperty({}, "tds-popover__button--".concat(theme), !!theme));
      var dynamicProps = tooltipBehavior ? {
        onMouseEnter: function onMouseEnter() {
          return _this5.onMouseEnter();
        },
        onMouseLeave: function onMouseLeave() {
          return _this5.onMouseLeave();
        }
      } : {
        onClick: function onClick(evt) {
          evt.stopPropagation();

          _this5.toggleTooltip();
        }
      };
      var dynamicTooltipProps = tooltipBehavior ? {
        onMouseEnter: function onMouseEnter() {
          return _this5.onMouseEnter();
        },
        onMouseLeave: function onMouseLeave() {
          return _this5.onMouseLeave();
        }
      } : {};
      var finalElement = onFocusBehavior ?
      /*#__PURE__*/
      // If it's onFocusBehavior (probably for an <input>/<textarea>), we have to
      // clone the element and override its
      // onFocus/onBlur, as we need to use them
      // to control the internal state of the popover.
      // Moreover we need to call the original events
      // if they're passed as props.
      // Finally, if we have a Component as a children (so, stateful Component)
      // we also have the ref to set
      cloneElement(Children.only(children), _objectSpread(_objectSpread({}, children.props), {}, {
        onFocus: function onFocus(evt) {
          if (children.props.onFocus) children.props.onFocus(evt);

          _this5.toggleTooltip(true);
        },
        onBlur: function onBlur(evt) {
          if (children.props.onBlur) children.props.onBlur(evt);

          _this5.toggleTooltip(false);
        }
      }, _objectSpread({}, children.type.prototype instanceof Component ? {
        ref: function ref(elem) {
          // set ref just if it's a React Component
          _this5._triggerWrapper = elem;
          var ref = children.ref;

          if (typeof ref === 'function') {
            ref(elem);
          }
        }
      } : {}))) :
      /*#__PURE__*/

      /**
       * Otherwise, we just need a simple span wrapper where we
       * inject the props to then control the Popover. Also,
       * we do a simple Children.only to check if the children is just one.
       * Otherwise it throws.
       */
      React.createElement("span", _extends({
        ref: function ref(elem) {
          return _this5._triggerWrapper = elem;
        }
      }, dynamicProps), Children.only(children));
      return /*#__PURE__*/React.createElement("div", {
        className: "tds-tooltip-wrapper",
        ref: function ref(elem) {
          return _this5._wrapper = elem;
        }
      }, finalElement, (rendered || forceCloseOnClick) && /*#__PURE__*/React.createElement("div", _extends({
        className: tooltipClassName,
        style: {
          width: width ? "".concat(width, "px") : 'auto',
          display: forceCloseOnClick ? "".concat(rendered ? 'block' : 'none') : 'block'
        }
      }, dynamicTooltipProps), title && /*#__PURE__*/React.createElement("h2", {
        className: "tds-popover__title"
      }, title), content, closable && /*#__PURE__*/React.createElement(Button, {
        theme: theme === 'alternative' ? 'tertiary-inverse' : 'tertiary',
        size: "sm",
        icon: "remove",
        className: buttonClassNames,
        onClick: function onClick() {
          return _this5.toggleTooltip(false, true);
        }
      })));
    }
  }]);

  return Popover;
}(Component);

Popover.displayName = "Popover";

_defineProperty(Popover, "propTypes", {
  theme: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,

  /**
   * Supported out of the box: light-bulb, info, info-variant, help, warning, eye.
   * If you want your own/custom icon (called "custom"), you just need to generate it on your application:
   * ```
   * .tds-popover--icon-custom {
   *   @include generate-icon(whatever-icon, $whatever-color);
   * }
   * ```
   */
  icon: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'auto']),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  width: PropTypes.number,
  push: PropTypes.oneOf(['left', 'right']),
  closable: PropTypes.bool,
  tooltipBehavior: PropTypes.bool,
  onFocusBehavior: PropTypes.bool,
  forceCloseOnClick: PropTypes.bool,
  onToggle: PropTypes.func,
  onClosed: PropTypes.func,
  animated: PropTypes.bool,
  rendered: PropTypes.bool,
  mouseLeaveTimeout: PropTypes.number
});

_defineProperty(Popover, "defaultProps", {
  placement: 'top',
  animated: true,
  push: null,
  tooltipBehavior: false,
  onFocusBehavior: false,
  closable: false,
  theme: '',
  className: '',
  title: '',
  icon: '',
  width: 0,
  forceCloseOnClick: false,
  onToggle: function onToggle() {},
  onClosed: function onClosed() {},

  /**
   * Passing rendered as a prop the Popover will be controlled
   * So it's up to the consumer displaying/hiding it
   */
  rendered: null,
  mouseLeaveTimeout: 100
});

export default Popover;